<button type="button" class="btn btn-primary">
    {{columnName}}
</button>